import axios from 'axios'
import store from '../store'
import path from './path'
/*
 * 定义请求类型
 */
const METHOD_QUERY = 'GET'
const METHOD_CREATE = 'POST'
const METHOD_SAVE = "PUT"
const METHOD_DELETE = "DELETE"
/**
 * @param method 请求类型
 * @param api 资源的路径，如['department'], 对于嵌套的资源与key相对应如: department/1/employee    
 * @param key 与资源对应，api.length - 1 <= key.length <= api.length 
 * @param param 上传的数据
 * @param isDownload 标示是否是文件下载
 **/
let paramParse = function (method, api, param, key, isDownload = false) {
    let url = ''
    key = key || [];
    if (key.length < api.length - 1 || key.length > api.length) {
        console.error('资源与参数不匹配');
        return false;
    }
    for (var i = 0; i < api.length; i++) {
        url += '/' + api[i];
        if (key[i]) {
            url += '/' + key[i];
        }
    }
    return new Promise((resolve, reject) => {
            let data = {
                headers: {
                    Authorization: store.getters.tokon, // header中加入token
                    Authorization91: store.getters.hlftokon // 加入海量发91的tokon
                },
                url: url,
                method: method,
            }
            if (store.getters.hubbleId > 0) {
                data.headers['Hubble-Id'] = store.getters.hubbleId
            }
            if (isDownload) {
                data['responseType'] = 'blob'
            }
            
            if (method === METHOD_QUERY) {
                data['params'] = param
            } else {
                data['data'] = param
            }
            axios(data).then((response) => {
                if (isDownload) {
                    resolve(response)
                } else {
                    if (response.data.status === 200) {
                        resolve(response.data.data)
                    } else if (response.data.status === 401) { // 登录失效
                        alert(response.data.msg)
                        // 进入登录页面
                        path.loginOut()
                    } else {
                        reject(response.data.msg)
                    }
                }
            }).catch((error) => {
                reject(error.message)
            })
    })
}
const Api = {
    /**
     * 查询操作
     */
    query (api, param, key, isDownload = false) {
        return paramParse(METHOD_QUERY, [api], param, key, isDownload)
    },
    /**
     * 查询操作
     */
    GET (api, param, key, isDownload = false) {
        return paramParse(METHOD_QUERY, [api], param, key, isDownload)
    },
    /**
     * 新增操作
     */
    create (api, param) {
        return paramParse(METHOD_CREATE, [api], param)
    },
    /**
     * 新增操作
     */
    POST (api, param) {
        return paramParse(METHOD_CREATE, [api], param)
    },
    /**
     * 修改操作
     */
    save (api, param, key) {
        return paramParse(METHOD_SAVE, [api], param, key)
    },
    /**
     * 修改操作
     */
    PUT (api, param, key) {
        return paramParse(METHOD_SAVE, [api], param, key)
    },
    /**
     * 删除操作
     */
    delete (api, param, key) {
        return paramParse(METHOD_DELETE, [api], param, key)
    },
    /**
     * 删除操作
     */
    DELETE (api, param, key) {
        return paramParse(METHOD_DELETE, [api], param, key)
    },
    /**
     * 登录
     */
    login: {
        api: 'member/login',
        submit (param) {
            return Api.create(this.api, param)
        }
    }
}

export default Api


// WEBPACK FOOTER //
// ./src/utils/api.js